import { addDays, format, parseISO } from 'date-fns';
import { useDataProvider } from 'ra-core';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const PaymentTermsWatcher = () => {
    const { setValue } = useFormContext();
    const salesOrderId = useWatch({ name: 'sales_order_id' });
    const invoiceDate = useWatch({ name: 'date' });
    const paymentTermDays = useWatch({ name: 'payment_term_days' });
    const dataProvider = useDataProvider();

    // 1. Fetch SO details when sales_order_id changes
    useEffect(() => {
        if (salesOrderId) {
            dataProvider.getOne('sales_orders', { id: salesOrderId })
                .then(({ data }) => {
                    if (data) {
                        if (data.payment_term_days) {
                            setValue('payment_term_days', data.payment_term_days);
                        }
                        if (data.terms_conditions) {
                            setValue('payment_terms', data.terms_conditions);
                        }
                    }
                })
                .catch(err => console.error('Error fetching SO for payment terms:', err));
        }
    }, [salesOrderId, dataProvider, setValue]);

    // 2. Calculate due_date when date or paymentTermDays changes
    useEffect(() => {
        if (invoiceDate && paymentTermDays !== undefined) {
            try {
                const baseDate = typeof invoiceDate === 'string' ? parseISO(invoiceDate) : invoiceDate;
                if (!isNaN(baseDate.getTime())) {
                    const dueDate = addDays(baseDate, parseInt(paymentTermDays) || 0);
                    setValue('due_date', format(dueDate, 'yyyy-MM-dd'));
                }
            } catch (e) {
                console.error('Error calculating due date:', e);
            }
        }
    }, [invoiceDate, paymentTermDays, setValue]);

    return null;
};
